import { NgModule, ModuleWithProviders } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpClientModule } from '@angular/common/http'
import { CommonModule } from '@angular/common'
import { IcosProgressModule } from '../progress/module'
import { IcosButtonsModule } from '../button/module'
import { IcosUploadRequest } from './upload.request'
import { IcosUpload } from './upload'
import { IcosUploadList } from './upload.list'
import { IcosUploadDragger } from './upload.dragger'


@NgModule({
  declarations: [IcosUpload, IcosUploadList, IcosUploadDragger],
  exports: [IcosUpload],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    IcosButtonsModule,
    IcosProgressModule,
  ],
  entryComponents: [IcosUpload],
})
export class IcosUploadModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosUploadModule, providers: [IcosUploadRequest] }
  }
}
